import { SQLService } from '../../services/sql.service';
import { Flip } from '../../app.animations';
import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ModalController,NavParams } from '@ionic/angular';
@Component({
  selector: 'ng-cheques-select-job',
  templateUrl: './select-job.page.html',
  styleUrls: ['./select-job.page.styl'],
  animations: [ Flip ]
})
export class SelectJobPage implements OnInit {
  constructor(
    private router: Router,
    public sql: SQLService,
    private params: NavParams,
    private route: ActivatedRoute,
    private navCtrl: ModalController,
    private location: Location
  ) {
    var s = params.get('selected');
    if(s)this.selected = s.split(',');
    this.multiple = params.get('select_multiple');
    this.router.events.subscribe((eve) => {
      if(eve instanceof NavigationEnd) this.get_jobs();
    });
  }
  jobs = [];
  count = -1;
  selected =[];
  multiple: boolean;
  output = new EventEmitter();
  @Input('set_table') table:string;
  @Input('set_model') model:string;
  @Input('set_model_id') id:string;
  ngOnInit() {
    this.get_jobs();
    this.id = this.route.snapshot.paramMap.get("id");
    this.table = this.route.snapshot.paramMap.get("table");
    this.model = this.route.snapshot.paramMap.get("model");
  }
  edit(job, item?) {
    this.router.navigate(['folder','Job',job.job_id]);
    this.navCtrl.dismiss();
  }
  delete(job, item) {
    if(confirm(this.sql.word.Delete_Job_Confirmation)) {
      this.sql.delete('Jobs','job_id',job.job_id);
      this.get_jobs();
    } else { item.closeSlidingItems(); }
  }
  get_jobs(event?) {
    this.sql.fetch('Jobs',(e)=>{
      this.jobs=e;
      this.count=e.length;
      setTimeout(()=>{if (event) event.target.complete();},1234);
    });
  }
  select_none() {this.navCtrl.dismiss(-1);}
  select(e) {
    if(this.multiple){
      this.toggle_item(e);
    } else {
      this.navCtrl.dismiss(e);
    }
  }
  done_multiple() {
    this.navCtrl.dismiss(this.selected.join(','));
  }
  toggle_item(item) {
    if( this.selected.includes(item.job_id) ) {
      this.deselect_item(item);
    } else {
      this.select_item(item);
    }
  }
  select_item(item) {
    this.selected.push(item.job_id);
  }
  deselect_item(item) {
    var new_selection=[];
    for(var i = 0; i < this.selected.length; ++i){
      if(this.selected[i]!=item.job_id){
        new_selection.push(this.selected[i]);
      }
    }
    this.selected = new_selection;
  }
  select_all() {
    var new_selection=[];
    for (var i = 0; i < this.jobs.length; ++i) {
      new_selection.push(this.jobs[i].job_id);
    }
    this.selected=new_selection;
  }
  deselect_all() {
   this.selected = []; 
  }
  add() {
    this.router.navigate(['folder','Job','New']);
    this.navCtrl.dismiss();
  }
  off() {
    if(this.multiple){
      this.done_multiple();
     } else {
      this.navCtrl.dismiss();
     }
  }
}